export default class InterestModel {
    public id: string = '';
    public source: string = '';
    public type: string = '';
    public favourite: boolean = false;
}
